<template>
  <div class="content">
    <div class="row mt-0">
      <div class="col-12">
        <h4 slot="header" class="card-title text-left m-0">
          Exportar AEJ TXT
        </h4>

        <div
          class="tab-content"
          id="pills-tabContent"
          style="min-height: 100px;"
        >
          <div
            v-show="itemMenu == 1"
            class="tab-pane fade"
            :class="itemMenu == 1 ? 'show active' : ''"
          >
            <div class="row center-content-center mt-4">
              <div class="col-md-12 text-left mt-4 row">
                <label>
                  Posto de Trabalho
                </label>
                <el-select
                  name="posto"
                  required
                  class="select-success col-sm-12 pagination-select"
                  v-model="payload.id_posto"
                  :class="error.id_posto === true ? 'has-danger' : ''"
                  placeholder="Selecione o Posto de Trabalho"
                >
                  <el-option
                    v-for="item in postos"
                    :key="item.id"
                    class="select-success"
                    :label="item.local"
                    :value="item.id"
                    >{{ item.local }}</el-option
                  >
                </el-select>
              </div>

              <div class="col-md-12 text-left mt-4 row">
                <label>
                  Departamento
                </label>
                <el-select
                  name="departamento"
                  required
                  class="select-success col-sm-12 pagination-select"
                  v-model="payload.id_departamento"
                  :class="error.id_departamento === true ? 'has-danger' : ''"
                  placeholder="Selecione o Departamento"
                >
                  <el-option
                    v-for="item in departamentos"
                    :key="item.id"
                    class="select-success"
                    :label="item.descricao"
                    :value="item.id"
                    >{{ item.descricao }}</el-option
                  >
                </el-select>
              </div>

              <div class="col-sm-12 text-left mt-1 form-group has-label row">
                <label>
                  Funcionário
                </label>
                <autocomplete
                  class="col-12"
                  :search="carregarFuncionario"
                  placeholder="Selecionar Funcionário"
                  aria-label="Selecionar Funcionário"
                  :get-result-value="procurarFuncionario"
                  @submit="selecionarFuncionario"
                >
                </autocomplete>
              </div>

              <div class="col-md-12 text-left mt-4 row">
                <div class="col-md-6 text-left">
                  <base-input
                    label="Data Inicial"
                    type="date"
                    placeholder="dia/mês/ano"
                    v-model="payload.data_inicial"
                  >
                  </base-input>
                </div>
                <div class="col-md-6 text-left">
                  <base-input
                    label="Data Final"
                    type="date"
                    placeholder="dia/mês/ano"
                    v-model="payload.data_final"
                  >
                  </base-input>
                </div>
              </div>

              <div class="col-sm-12 justify-content-end mt-4 row">
                <div class="text-center col-sm-3 col-8 animation-on-hover">
                  <base-button
                    block
                    type="success"
                    @click="exportarAEJ()"
                    :disabled="validateForm()"
                    >Exportar Arquivo</base-button
                  >
                </div>
                <div class="text-center col-sm-3 col-8 animation-on-hover">
                  <base-button block type="warning" @click="limparFiltro"
                    >Limpar Filtros</base-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="vld-parent">
      <loading
        :active.sync="isLoading"
        :can-cancel="false"
        loader="spinner"
        color="#35a887"
        :is-full-page="true"
      >
      </loading>
    </div>
  </div>
</template>
<script>
import Loading from "vue-loading-overlay";
import swal from "sweetalert2";
import { Card, BaseInput } from "@/components/index";
import Fuse from "fuse.js";
import { Select, Option } from "element-ui";
import Modal from "@/components/Modal.vue";
import { saveAs } from "file-saver";
import moment from "moment";

export default {
  data() {
    return {
      openDialog: false,
      isLoading: false,
      itemMenu: 1,
      file: null,
      fuseSearch: null,
      dadosUsuario: "",
      sinc_or_create: "Sincronizando",
      funcionarios: [],
      postos: [],
      departamentos: [],
      block: {
        departamento: true,
        posto: true,
        funcionario: true,
        data_final: "",
        data_inicial: "",
      },
      payload: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
        idUsuario: "",
        id_empregador: "",
      },
      config: {
        faltasHoras: "",
        faltasDias: "",
        atrasoHoras: "",
        adNoturnoHoras: "",
        horaExtra50: "",
        horaExtra100: "",
      },
      error: {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
        idUsuario: "",
      },
    };
  },
  components: {
    Loading,
    BaseInput,
    Card,
    Modal,
  },

  mounted() {
    this.listarDepartamentos();
    this.listarPostos();
    this.listarFuncionarios();
    this.listarRubricas();
  },

  methods: {
    limparFiltro() {
      this.payload = {
        data_final: "",
        data_inicial: "",
        id_departamento: "",
        id_posto: "",
        id_funcionario: "",
      };
    },

    validateForm() {
      if (this.payload.data_final && this.payload.data_inicial) {
        return false;
      }
      return true;
    },

    carregarDadosUsuario() {
      this.dadosUsuario = this.$cookies.get("usuario") || null;
    },
    selecionarFuncionario(result) {
      if (result) {
        this.payload.id_funcionario = result.id;
        return result.nome;
      } else return "";
    },
    procurarFuncionario(result) {
      if (result) return result.nome;
      else return "";
    },
    carregarFuncionario(input) {
      if (input.length > 1) return this.fuseSearch.search(input);
      else {
        this.payload.id_funcionario = "";
        return this.funcionarios;
      }
    },

    listarDepartamentos() {
      let th = this;
      this.block.departamento = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/departamento/listarDepartamentos", bodyFormData)
        .then((response) => {
          th.block.departamento = false;
          th.departamentos = response.data.data.dados;
        })
        .catch((err) => {
          th.block.departamento = false;
          console.log(err);
        });
    },

    listarRubricas() {
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/exportacao/listarRubricas", bodyFormData)
        .then((response) => {
          th.rubricas = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    listarPostos() {
      this.block.posto = true;
      let th = this;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
      };
      this.axios
        .post("/api/empregador/listarTodosEmpregadores2", bodyFormData)
        .then((response) => {
          th.block.posto = false;
          th.postos = response.data.data.dados;
        })
        .catch((err) => {
          console.log(err);
          th.block.posto = false;
        });
    },

    listarFuncionarios() {
      let th = this;
      this.block.funcionario = true;

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        idUsuario: "",
      };

      if (this.dadosUsuario) {
        bodyFormData.idUsuario = this.dadosUsuario.id;
      }

      this.axios
        .post("/api/empregado/listarEmpregados2", bodyFormData, {
          headers: {
            "id-actor": this.$cookies.get("id_actor"),
            "tipo-actor": this.$cookies.get("tipo_actor"),
          },
        })
        .then((response) => {
          th.block.funcionario = false;
          th.funcionarios = response.data.data.dados;

          th.fuseSearch = new Fuse(th.funcionarios, {
            keys: ["nome", "cpf"],
            threshold: 0.3,
          });
        })
        .catch((err) => {
          th.block.funcionario = false;
        });
    },

    exportarAEJ() {
      this.openDialog = false;
      this.isLoading = true;
      let th = this;

      const data = moment().format("YYYYMMDDHHmmss");

      let bodyFormData = {
        setDB: this.$cookies.get("db"),
        data_final: this.payload.data_final,
        data_inicial: this.payload.data_inicial,
        id_departamento: this.payload.id_departamento,
        id_posto: this.payload.id_posto,
        id_empregador: this.$cookies.get("idEmpregador"),
        id_funcionario: this.payload.id_funcionario,
      };
      this.axios
        .post("/api/exportacao/arquivoAEJ", bodyFormData, {
          responseType: "blob",
        })
        .then((response) => {
          const blob = new Blob([response.data], { type: "text/plain" });
          saveAs(blob, `AEJ${data}.txt`);
        })
        .catch((err) => {
          th.showSwal(
            "auto-close",
            "Erro",
            "Ocorreu algum erro ao exportar arquivo!",
            "error",
          );
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    showSwal(type, title, text, typeMsg) {
      if (type === "auto-close") {
        swal({
          title: title,
          text: text,
          type: typeMsg,
          timer: 3000,
          showConfirmButton: false,
        });
      }
    },
  },
};
</script>
